import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PaymentState } from './payment.state';

const selectPaymentMethodsState = createFeatureSelector<PaymentState>('payment');

export const getSelectedPaymentMethod = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state?.selectedPaymentMethod
);

export const getSelectedPaymentMethodFinal = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state?.selectedPaymentMethodFinal
);
export const getPaymentDetails = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state?.paymentDetails.values
);
export const getPaymentModeGovernmentIdMandatory = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state?.paymentModeInfo.governmentIdMandatory
);
export const getPaymentMethodsState = createSelector(selectPaymentMethodsState, (state: PaymentState) => state?.methods);
export const getPaymentDetailsValid = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state?.paymentDetails.valid
);
export const getPaymentDetailsSaveCard = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state?.paymentDetails.saveCard
);
export const getPaymentReady = createSelector(selectPaymentMethodsState, (state: PaymentState) => state.paymentReady);
export const getPaymentLoading = createSelector(selectPaymentMethodsState, (state: PaymentState) => state.loading);
export const getPaymentLoaded = createSelector(selectPaymentMethodsState, (state: PaymentState) => state.loaded);
export const getSelectedDiscount = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state?.selectedDiscount
);
export const isRepay = createSelector(selectPaymentMethodsState, (state: PaymentState) => state.isRepay);

export const getPaymentMethods = createSelector(selectPaymentMethodsState, (state: PaymentState) => state.methods.values);

export const getFilteredPaymentMethods = createSelector(
    selectPaymentMethodsState,
    (state: PaymentState) => state.filteredMethods.values
);
